import {useFormik} from 'formik'
import * as Yup from 'yup'
import {
  Update_Profile,
  getAccountDetails,
} from './Update_API'
import {useState, useEffect} from 'react'
import Swal from 'sweetalert2'
import MuiPhoneNumber from 'material-ui-phone-number'
import clsx from 'clsx'
import '../../../_metronic/assets/sass/core/components/_variables.scss'
import {MDBCard, MDBCardBody, MDBCol, MDBInput, MDBRow} from 'mdb-react-ui-kit'
import VerifyEmail from './VerifyEmail'
import VerifyContactNumber from './VerifyContactNumber'
import ChangePassword from './ChangePassword'
import { useAuth } from '../../modules/auth'

const UpdateNewProfile: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [loader, setLoader] = useState(false)
  const [modalContactIsOpen, setModalContactIsOpen] = useState(false)
  const [modalEmailIsOpen, setmodalEmailIsOpen] = useState(false)
  const [contactNo, setContactNo] = useState<string>('')
  const [getEmail, setGetEmail] = useState<string>('')
  const [accVerify, setAccVerify] = useState<number | 0>(0)
  const [disable, setDisable] = useState(false)
  const [disablemail, setDisableEmail] = useState(false)
  const [showChangePassword, setShowChangePassword] = useState(false)
  const [profileData, setProfileData] = useState({
    accouont_holder_name: '',
    contact_number: '',
    email_id: '',
  })
  const [editView, setEditView] = useState(false)

  const initialValues = {
    fname: '',
    lname: '',
    address: '',
    state: '',
    pincode: '',
    email: '',
    //password:'',
    contactno: '',
  }
  const registrationSchema = Yup.object().shape({
    fname: Yup.string()
      .matches(/^[A-Za-z ]+$/, 'Name should contain only alphabetic characters')
      .min(3, 'Minimum 3 characters')
      .max(50, 'Maximum 50 symbols')
      .required('Name is required'),
    lname: Yup.string().optional().min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols'),
    //.required('Last name is required'),
    address: Yup.string().optional(),
    state: Yup.string().optional(),
    pincode: Yup.number().min(6, 'Minimum 6 number required'),
    //.required('Pincode is required'),
    email: Yup.string()
      .email('Wrong email format')
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Email is required'),
    contactno: Yup.string()
      // .matches(/^\+91\s\d{5}-\d{5}$/, 'Invalid Format')
      .required('Contact Number name is required'),
  })
  const {setCurrentUser} = useAuth()
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        let body = {
          accouont_holder_name: values.fname,
          email_id: values.email,
          password: '11111111',
          contact_number: values.contactno,
        }
        let phone = values.contactno.replace('-', '').replace('\\s', '')

        const {data: resp} = await Update_Profile(values.fname, values.email, values.contactno)

        if (resp.code === '200') {
          setLoader(false)
          const {data: response} = await getAccountDetails()
          setCurrentUser(response)
          Swal.fire({
            title: 'Profile updated successfully',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            }
          })
        } else {
          setLoader(false)
          const errorMessage = resp.msg_details
          Swal.fire({
            title: errorMessage,
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          }).then((result) => {
            setLoading(false)
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
  })

  async function getProfileData() {
    try {
      const {data: response} = await getAccountDetails()
      setCurrentUser(response)
      if (response) {
        setGetEmail(response.email_id)
        setContactNo(response.contact_number)
        setAccVerify(response.account_verified)
        localStorage.setItem('account_verified', response.account_verified)
        setProfileData(response)

        formik.setValues({
          fname: response.accouont_holder_name,
          lname: '',
          address: '',
          state: '',
          email: response.email_id,
          pincode: '',
          contactno: response.contact_number,
        })
      }

      {
        response.account_verified === 2 || response.account_verified === 3
          ? setDisable(true)
          : setDisable(false)
      }
      {
        response.account_verified === 1 || response.account_verified === 3
          ? setDisableEmail(true)
          : setDisableEmail(false)
      }
    } catch (error) {}
  }

  useEffect(() => {
    getProfileData()
  }, [])

  return (
    <>
      {!editView && (
        <div style={{marginBottom: 20}} className={`card card-flush`}>
          <div>
            <button
              style={{width: 140, height: 50, marginRight: 20, marginTop: 20, float: 'right'}}
              className='btn btn-lg btn-primary w-3 mb-3'
              onClick={() => setEditView(true)}
            >
              Edit Profile
            </button>
            <button
              style={{height: 50, marginRight: 20, marginTop: 20, float: 'right'}}
              className='btn btn-lg btn-primary w-3 mb-3'
              onClick={() => setShowChangePassword(true)}
            >
              Reset password
            </button>
           
              <ChangePassword
            setShowChangePassword={setShowChangePassword}
            showChangePassword={showChangePassword}
          />
            
          </div>
          <div className='card-header pt-5'>
            <div className='card-title d-flex flex-column'>
              <div style={{marginBottom: 10}} className='d-flex align-items-center'>
                <span className='fs-1hx fw-bold text-dark'>{profileData.accouont_holder_name}</span>
              </div>
              <div style={{marginBottom: 5}} className='d-flex align-items-center'>
                <span className='fs-1hx text-dark'>{profileData.email_id}</span>{' '}
                {accVerify === 1 || accVerify === 3 ? (
                  <span style={{marginLeft: 10}} className='badge badge-light-success'>
                    Verified
                  </span>
                ) : (
                  <div>
                    <span style={{marginLeft: 10}} className='badge badge-light-danger'>
                      Unverified
                    </span>
                    <span
                      className='badge badge-light-primary'
                      style={{cursor: 'pointer'}}
                      onClick={() => setmodalEmailIsOpen(true)}
                    >
                      Click to Verify
                    </span>
                  </div>
                )}
              </div>
              <div style={{marginBottom: 5}} className='d-flex align-items-center'>
                <span className='fs-1hx text-dark'>{profileData.contact_number}</span>
                {accVerify === 2 || accVerify === 3 ? (
                  <span style={{marginLeft: 10}} className='badge badge-light-success'>
                    Verified
                  </span>
                ) : (
                  <div>
                    <span style={{marginLeft: 10}} className='badge badge-light-danger'>
                      Unverified
                    </span>
                    <span
                      className='badge badge-light-primary'
                      style={{cursor: 'pointer'}}
                      onClick={()=>setModalContactIsOpen(true)}
                    >
                      Click to Verify
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <VerifyEmail
            getEmail={getEmail}
            getProfileData={getProfileData}
            setmodalEmailIsOpen={setmodalEmailIsOpen}
            modalEmailIsOpen={modalEmailIsOpen}
          />

          <VerifyContactNumber
            contactNo={contactNo}
            getProfileData={getProfileData}
            setModalContactIsOpen={setModalContactIsOpen}
            modalContactIsOpen={modalContactIsOpen}
          />
        </div>
      )}

      {editView && (
        <form
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          noValidate
          id='kt_login_signin_form'
          onSubmit={formik.handleSubmit}
        >
          <div style={{marginBottom: 20}} className={`card card-flush`}>
            <MDBRow>
              <MDBCol md='10' className='mb-4 mx-18'>
                <MDBCard className='mb-4'>
                  <MDBCardBody>
                    {formik.status && (
                      <div className='mb-lg-15 alert alert-danger'>
                        <div className='alert-text font-weight-bold'>{formik.status}</div>
                      </div>
                    )}
                    <MDBRow className='mb-4'>
                      <div className='error'> {} </div>
                    </MDBRow>
                    <MDBRow className='fv-row mb-3'></MDBRow>

                    <MDBRow className='fv-row mb-3'>
                      <MDBCol className='form-label fw-bolder text-dark fs-6'>
                        <label className='form-label fw-bolder text-dark fs-6'>Name *</label>

                        <MDBInput
                          label=''
                          type='text'
                          autoComplete='off'
                          {...formik.getFieldProps('fname')}
                          className={clsx(
                            'form-control bg-transparent',
                            {
                              'is-invalid': formik.touched.fname && formik.errors.fname,
                            },
                            {
                              'is-valid': formik.touched.fname && !formik.errors.fname,
                            }
                          )}
                        />
                        {formik.touched.fname && formik.errors.fname && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.fname}</span>
                            </div>
                          </div>
                        )}
                      </MDBCol>
                    </MDBRow>

                    <MDBRow className='fv-row mb-1'>
                      <div className='form-label fw-bolder text-dark fs-6'>
                        <label className='form-label fw-bolder text-dark fs-6'>Email</label>
                        <MDBInput
                          type='text'
                          autoComplete='off'
                          disabled={disablemail}
                          {...formik.getFieldProps('email')}
                          className={clsx(
                            'form-control bg-transparent',
                            {
                              'is-invalid': formik.touched.email && formik.errors.email,
                            },
                            {
                              'is-valid': formik.touched.email && !formik.errors.email,
                            }
                          )}
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.email}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </MDBRow>

                    <MDBRow className='fv-row mb-3'>
                      <div className='fv-row mb-8'>
                        <label className='form-label fw-bolder text-dark fs-6'>Phone</label>
                        <MuiPhoneNumber
                          disabled={disable}
                          defaultCountry={'in'}
                          {...formik.getFieldProps('contactno')}
                          onChange={(value) => formik.setFieldValue('contactno', value)}
                          className={clsx(
                            'form-control bg-transparent',
                            {'is-invalid': formik.touched.contactno && formik.errors.contactno},
                            {'is-valid': formik.touched.contactno && !formik.errors.contactno}
                          )}
                        />

                        {formik.touched.contactno && formik.errors.contactno && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.contactno}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </MDBRow>

                    <div className='text-center fv-row mb-8'>
                      <button
                        style={{marginRight: 15}}
                        onClick={() => setEditView(false)}
                        className='btn btn-lg btn-primary w-3  mb-3'
                      >
                        Discard
                      </button>
                      <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className='btn btn-lg btn-primary w-3  mb-3'
                        disabled={formik.isSubmitting || !formik.isValid}
                      >
                        {!loading && <span className='indicator-label'>Submit</span>}
                        {loading && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            Please wait...{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </MDBRow>
          </div>
        </form>
      )}
    </>
  )
}
export default UpdateNewProfile
